export const transactionTypesEnum = Object.freeze({
  deposit: 'Deposit',
  withdrawal: 'Withdrawal',
  cardPayment: 'CardPayment',
  walletPayment: 'WalletPayment',
  reversal: 'Reversal',
  bankTransferPayment: 'Bank_Transfer_Payment',
  AdditionalCharge: 'AdditionalCharge'
});
